<template>
  <!-- 中奖弹窗 -->
  <van-popup v-model="showImg" class="transparent-popup">
    <div class="v-pop-gift">
      <div class="content">
        <div class="btn-close" @click="close"></div>
        <div class="pop-title">恭喜您中奖</div>
        <div class="wrap-box">
          <div class="arr"></div>
          <div class="banner">
            <div class="mask"></div>
            <van-image class="s" :src="superInfo.activityBigImg" fit="cover" />
          </div>
          <div class="txt-box">
            <div class="tit text-line">
              {{ superInfo.activityName }}
            </div>
            <div class="t1 text-line" :style="{ color: bgColor }">
              {{ superInfo.artistNameList }}
            </div>
            <div class="t2">{{ actTime }}</div>
            <div class="t3">{{ superInfo.location }}</div>
          </div>
        </div>
        <div class="tips">
          <div class="t1">温馨提醒：</div>
          <div class="t2">
            {{ superInfo.receiveTips ? superInfo.receiveTips : tips }}
          </div>
        </div>
        <div class="ft">
          <div class="confirm" @click="handleConfirm">
            {{ superInfo.prizeType == 2 ? "提交信息，去确认" : "确认领取" }}
          </div>
          <div class="giveup" @click="handleGiveup">我要放弃</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup as VanPopup, Image as VanImage } from "vant";

export default {
  name: "VPopImg",

  components: {
    VanPopup,
    VanImage,
  },

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
    actTime: {
      type: String,
      default: () => "",
    },
    bgColor: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      // 展示弹窗
      showImg: false,
      imgUrl: "",
      tips: "中奖用户请在【兑奖时间】内确认是否领取奖品哦！线下活动类奖品，确认领取后未到场，视为自动放弃，且当月暂时无法报名其他动感地带芒果卡超级现场活动；无法前往可点【放弃】，后续报名完全不受影响～",
    };
  },

  methods: {
    // 显示弹窗
    open() {
      this.showImg = true;
    },
    // 关闭弹窗
    close() {
      this.showImg = false;
    },

    // 确认领取
    handleConfirm() {
      this.$emit("handleConfirm", 1);
    },

    // 我要放弃
    handleGiveup() {
      this.$emit("handleConfirm", 4);
    },
  },
};
</script>

<style lang="less" scoped>
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  图片弹窗
.v-pop-gift {
  position: relative;
  width: 320px;
  .pop-title {
    padding: 10px 16px;
    text-align: center;
    font-weight: 500;
    font-size: 21px;
    color: #001a33;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
  }
  .content {
    position: relative;
    width: 320px;
    margin: 0 auto;
    min-height: 300px;
    padding-bottom: 110px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #474747;
    text-align: center;
    background: #fff;
    border-radius: 26px;
    background-image: url("../assets/image/bg-pop-gift01.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center top;

    .btn-close {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 22px;
      height: 22px;
      background-image: url("../assets/image/icon-pop-close.png");
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
    }
    .wrap-box {
      position: relative;
      width: 250px;
      height: 345.5px;
      margin: 0 auto;
      padding: 25px 32px 0;
      background-image: url("../assets/image/bg-pop-gift.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center top;
      box-sizing: border-box;
      .line {
        position: absolute;
        top: 261px;
        left: 23px;
        z-index: 10;
        width: 206px;
        height: 1px;
        border-top: 1px dashed rgba(16, 16, 13, 0.24);
        opacity: 0.24;
      }
      .arr {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        width: 65px;
        height: 67.5px;
        background-image: url("../assets/image/icon-gift-arr.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }
      .banner {
        position: relative;
        width: 186px;
        height: 258px;
        margin: 0 auto;
        .s {
          overflow: hidden;
          width: 100%;
          height: 100%;
          border-radius: 10px 10px 0 0;
        }
        .mask {
          position: absolute;
          bottom: -2px;
          left: -1px;
          z-index: 2;
          width: 188px;
          height: 91px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.79) 50%,
            #ffffff 70%,
            #ffffff 100%
          );
        }
      }
      .txt-box {
        position: absolute;
        left: 50%;
        bottom: 35px;
        z-index: 5;
        width: 188px;
        margin-left: -94px;
        text-align: left;
        box-sizing: border-box;
        .tit {
          margin-bottom: 4px;
          line-height: 1.3;
          font-weight: 600;
          font-size: 15px;
          color: #001a33;
        }
        .t1 {
          margin-bottom: 4px;
          font-weight: 400;
          font-size: 10px;
        }
        .t2,
        .t3 {
          font-weight: 400;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.54);
        }
      }
    }
    .tips {
      width: 226px;
      margin: 0 auto 5px;
      text-align: left;
      .t1 {
        font-weight: 500;
        font-size: 9.5px;
        color: rgba(0, 26, 51, 0.5);
      }
      .t2 {
        font-weight: 400;
        font-size: 9.5px;
        color: rgba(0, 26, 51, 0.3);
      }
    }
    .ft {
      position: absolute;
      left: 0;
      bottom: 10px;
      width: 100%;
      .confirm {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 240px;
        height: 45px;
        margin: 0 auto 5px;
        font-weight: 500;
        font-size: 16px;
        color: #001a33;
        background-image: url("../assets/image/icon-gift-btn.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center top;
        box-sizing: border-box;
      }
      .giveup {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 240px;
        height: 45px;
        margin: 0 auto;
        font-weight: 500;
        font-size: 16px;
        color: rgba(0, 26, 51, 0.3);
      }
    }
  }
}
</style>
